import { formatDate as formatDateAng } from '@angular/common';

export function format(date): string {
    // TODO: Faire un meilleur check pour vérifier la nullité de la date
    if (date === null) {
        return null;
    }
    date = new Date(date);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    let dateOfString = date.getFullYear() + '-';
    dateOfString += (('' + month).length < 2 ? '0' : '') + month + '-';
    dateOfString += (('' + day).length < 2 ? '0' : '') + day;
    return dateOfString;
}

export function formatDateInt(aValue, aDateEnd) {
    // Si passage par un écran de saisie, le composant date ramène un timezone
    if (aValue.getTimezoneOffset !== undefined) {
        let woffset = aValue.getTimezoneOffset();
        aValue.setMinutes(aValue.getMinutes() - woffset);
        aValue = JSON.stringify(aValue);
        if (aDateEnd === true) {
            aValue = aValue.substring(1, 11) + ' 23:59:59';
        } else {
            aValue = aValue.substring(1, 11) + ' 00:00:00';
        }
    } else {
        if (aDateEnd === true) {
            aValue = aValue.substring(0, 10) + ' 23:59:59';
        } else {
            aValue = aValue.substring(0, 10) + ' 00:00:00';
        }        
    }
    return aValue;
}

export function formatDateUserFrToInternal(aDate) {
    // A n'utiliser que pour une date de la forme dd/mm/yyyy
    return aDate.substring(6, 10) + '-' + aDate.substring(3, 5) + '-' + aDate.substring(0, 2);
}

export function formatEu(date) {
    // TODO: Faire un meilleur check pour vérifier la nullité de la date
    // TODO: Utiliser la fonction native Date.toLocaleDateString() pour le formatage au format local (soit dd/mm/yyyy en europe)
    if (date === null) {
        return null;
    }
    date = new Date(date);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    let dateOfString = (('' + day).length < 2 ? '0' : '') + day + '/';
    dateOfString += (('' + month).length < 2 ? '0' : '') + month + '/';
    dateOfString += date.getFullYear();
    return dateOfString;
}

export function formatTime(date) {
    let currentTimezone = date.getTimezoneOffset();
    currentTimezone = (currentTimezone / 60) * -1;
    let gmt = '';
    if (currentTimezone !== 0) {
        gmt += currentTimezone > 0 ? '+' : ' ';
        gmt += (currentTimezone < 10 ? '0' + currentTimezone : currentTimezone) + ':00';
    }
    let dateOfString = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    dateOfString += (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    dateOfString += date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    dateOfString += gmt;
    return dateOfString;
}

export function dateFormat(date, format, lang ='fr-FR') {
    try {

        let DateFormated: Date;
        if (date === null) {
            DateFormated = new Date();
        } else {
            let dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
            if(dateRegex.test(date)){
                let parts = date.split("/");
                DateFormated = new Date(+parts[2], +parts[1] - 1, +parts[0]);
            } else {
                DateFormated = new Date(date);
            }

        }
        return formatDateAng(DateFormated, format, lang);
    } catch (error) {
        return 'Date invalide';
    }
}


export function formatRCF3339(date) {
    return format(date) + 'T' + formatTime(date);
}

export function formatDateTimeInternal(date) {
    return (format(date) + ' ' + formatTime(date)).substring(0, 19);
}

export function formatPeriod(period, format: string = null) {
    switch (format) {
        case 'RCF3339':
            return {
                from: formatRCF3339(period.from),
                to: formatRCF3339(period.to),
            };
        default:
            return {
                from: formatRCF3339(period.from).split('T')[0],
                to: formatRCF3339(period.to).split('T')[0],
            };
    }
}

export function verifyPeriod(aDateBegin, aDateEnd) {
    let wRes = true;
    let wDateBegin: Date;
    let wDateEnd: Date;
    if (aDateBegin != undefined && aDateEnd != undefined) {
        wDateBegin = aDateBegin;
        wDateBegin.setHours(0, 0, 0, 0);
        wDateEnd = aDateEnd;
        wDateEnd.setHours(0, 0, 0, 0);
        if (wDateBegin > wDateEnd) {
            wRes = false;
        }
    }
    return wRes;
}

export function setRangeDate(aRangeDates) {
    let wRange = {
        empty: false,
        dateBegin: null,
        dateEnd: null,
    };

    if (aRangeDates === null || aRangeDates === undefined) {
        wRange.empty = true;
    } else {
        if (aRangeDates[1] === null || aRangeDates[1] === undefined) {
            aRangeDates[1] = aRangeDates[0];
        }
        wRange.dateBegin = aRangeDates[0];
        wRange.dateEnd = aRangeDates[1];
    }
    return wRange;
}

export function setFormRangeData(aRange) {
    const formData = new FormData();
    formData.append('datebegin', formatDateInt(aRange.dateBegin, false));
    formData.append('dateend', formatDateInt(aRange.dateEnd, true));
    return formData;
}

export function prepareDate(aDate, aDatEend) {
    if (aDate != undefined) {
        return formatDateInt(aDate, aDatEend);
    } else {
        return '';
    }
}

export function diff_minutes(dt2, dt1) {
    let diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
}

export function setDateTime(date, datetime) {
    const wdate = new Date(date);
    const wstart = new Date(datetime);
    wstart.setFullYear(wdate.getFullYear());
    wstart.setMonth(wdate.getMonth());
    wstart.setDate(wdate.getDate());
    wstart.setSeconds(0);
    return wstart;
}

export function setTimeString(date, time) {
    const wdate = setTime(date, time);
    let wtime = wdate.toTimeString();
    wtime = wtime.substring(0, 5);
    return wtime;
}

export function setTime(date, time) {
    const wdate = new Date(date);
    let currentTimezone = wdate.getTimezoneOffset();
    currentTimezone = (currentTimezone / 60) * -1;
    const whour = parseInt(time.substring(0, 2), 10) + currentTimezone;
    wdate.setHours(whour, time.substring(3, 5));
    return wdate;
}

export function setTimeGmt(date, time) {
    const wdate = new Date(date);
    const whour = parseInt(time.substring(0, 2), 10);
    wdate.setHours(whour, time.substring(3, 5));
    return wdate;
}

export function check(date) {
    return date !== null ? new Date(date) : null;
}

export function decalDateDayHour(days: number, hours: number) {
    const now = new Date();
    now.setDate(now.getDate() + days);
    now.setHours(now.getHours() + hours);
    return formatRCF3339(now);
}

// Pour gerer les input directement dans le calendrier
// ajuste les heures, minutes et secondes.
export function setPeriod(from, to) {
    from.setHours(0);
    from.setMinutes(0);
    from.setSeconds(0);
    to.setHours(23);
    to.setMinutes(59);
    to.setSeconds(59);
    return { from: from, to: to };
}

export function getComputedDate(aOperator: any) {
    var fn;
    const actionDate = {
        TNoDate: get_NoDate,
        TNow: get_Now,
        TYesterday: get_Yesterday,
        TBeforeYesterday: get_BeforeYesterday,
        TTomorrow: get_Tomorrow,
        TPastTomorrow: get_PastTomorrow,
        TLastWeek: get_LastWeek,
        TNextWeek: get_NextWeek,
        TBeginMonth: get_BeginMonth,
        TEndMonth: get_EndMonth,
        TBeginPrevMonth: get_BeginPrevMonth,
        TEndPrevMonth: get_EndPrevMonth,
        TBeginNextMonth: get_BeginNextMonth,
        TEndNextMonth: get_EndNextMonth,
        TBeginYear: get_BeginYear,
        TEndYear: get_EndYear,
        TBeginPrevYear: get_BeginPrevYear,
        TEndPrevYear: get_EndPrevYear,
    };

    if (actionDate[aOperator]) {
        fn = actionDate[aOperator]();
    } else {
        fn = get_Def(aOperator);
    }
    return fn;
}

export function get_Def(aOperator) {
    if (aOperator === '' || aOperator === undefined || aOperator === null) {
        const _date = new Date();
        return _date;
    } else {
        return aOperator;
    }
}

export function get_NoDate() {
    return null;
}

export function get_Now() {
    const _date = new Date();
    return _date;
}

export function get_Yesterday() {
    const _date = new Date();
    _date.setDate(_date.getDate() - 1);
    return _date;
}

export function get_BeforeYesterday() {
    const _date = new Date();
    _date.setDate(_date.getDate() - 2);
    return _date;
}
export function get_Tomorrow() {
    const _date = new Date();
    _date.setDate(_date.getDate() + 1);
    return _date;
}
export function get_PastTomorrow() {
    const _date = new Date();
    _date.setDate(_date.getDate() + 2);
    return _date;
}
export function get_LastWeek() {
    const _date = new Date();
    _date.setDate(_date.getDate() - 7);
    return _date;
}
export function get_NextWeek() {
    const _date = new Date();
    _date.setDate(_date.getDate() + 7);
    return _date;
}

// Ne pas changer l'ordre des lignes
export function get_BeginMonth() {
    const _date = new Date();
    _date.setDate(1);
    _date.setMonth(_date.getMonth());
    return _date;
}

// Ne pas changer l'ordre des lignes
export function get_EndMonth() {
    const _date = new Date();
    _date.setMonth(_date.getMonth() + 1);
    _date.setDate(0);
    return _date;
}

// Ne pas changer l'ordre des lignes
export function get_BeginPrevMonth() {
    const _date = new Date();
    _date.setDate(1);
    _date.setMonth(_date.getMonth() - 1);
    return _date;
}

// Ne pas changer l'ordre des lignes
export function get_EndPrevMonth() {
    const _date = new Date();
    _date.setDate(0);
    _date.setMonth(_date.getMonth());
    return _date;
}

// Ne pas changer l'ordre des lignes
export function get_BeginNextMonth() {
    const _date = new Date();
    _date.setDate(1);
    _date.setMonth(_date.getMonth() + 1);
    return _date;
}

// Ne pas changer l'ordre des lignes
export function get_EndNextMonth() {
    const _date = new Date();
    _date.setMonth(_date.getMonth() + 2);
    _date.setDate(0);
    return _date;
}

// Ne pas changer l'ordre des lignes
export function get_BeginYear() {
    const _date = new Date();
    _date.setDate(1);
    _date.setMonth(0);
    return _date;
}

// Ne pas changer l'ordre des lignes
export function get_EndYear() {
    const _date = new Date();
    _date.setFullYear(_date.getFullYear() + 1);
    _date.setMonth(0);
    _date.setDate(0);
    return _date;
}

// Ne pas changer l'ordre des lignes
export function get_BeginPrevYear() {
    const _date = new Date();
    _date.setFullYear(_date.getFullYear() - 1);
    _date.setDate(1);
    _date.setMonth(0);
    return _date;
}

// Ne pas changer l'ordre des lignes
export function get_EndPrevYear() {
    const _date = new Date();
    _date.setFullYear(_date.getFullYear());
    _date.setMonth(0);
    _date.setDate(0);
    return _date;
}

export function getPeriod(days = 0, isSameDay = false, isAll = false) {
    const from = isAll ? new Date('1970-01-01') : new Date();
    const to = new Date();
    from.setDate(to.getDate() + days);
    if (isSameDay) {
        to.setDate(from.getDate());
        to.setMonth(from.getMonth());
        to.setFullYear(from.getFullYear());
    }
    return setPeriod(from, to);
}

export function getAll() {
    return getPeriod(0, false, true);
}
export function getToday() {
    const from = new Date();
    const to = from;
    return { from: from, to: to };
}
export function getYesterday() {
    let from = new Date();
    from.setDate(from.getDate() - 1);
    const to = from;
    return { from: from, to: to };
}
export function getBeforeYesterday() {
    let from = new Date();
    from.setDate(from.getDate() - 2);
    const to = from;
    return { from: from, to: to };
}
export function getLastSevenDays() {
    const to = new Date();
    let from = new Date();
    from.setDate(to.getDate() - 7);
    return { from: from, to: to };
}
export function getLastThirtyDays() {
    const to = new Date();
    let from = new Date();
    from.setDate(to.getDate() - 30);
    return { from: from, to: to };
}

export function getThisWeek(weeks = 0) {
    const from = new Date();
    const day = from.getDay();
    if (day === 0) {
        from.setDate(from.getDate() - 1);
    }
    from.setDate(from.getDate() + 1 - (from.getDay() - weeks * 7));
    const monday = new Date(from);
    monday.setDate(monday.getDate() + 6);
    const to = new Date(monday);
    return { from: from, to: to };
}
export function getLastWeek() {
    return getThisWeek(-1);
}

export function getThisMonth(months = 0) {
    const from = new Date();
    from.setDate(1);
    from.setMonth(from.getMonth() + months);
    const to = new Date(from.getTime());
    to.setMonth(from.getMonth() + 1);
    to.setDate(to.getDate() - 1);
    return { from: from, to: to };
}
export function getLastMonth() {
    return getThisMonth(-1);
}

export function getTrimester(trimesters = 0) {
    const trimesterMonths = [
        [0, 2],
        [3, 5],
        [6, 8],
        [9, 11],
    ];
    const fromTo = getThisMonth();
    const from = fromTo.from;
    const to = new Date();
    from.setMonth(from.getMonth() + 3 * trimesters);
    trimesterMonths.map((trimester) => {
        if (from.getMonth() >= trimester[0] && from.getMonth() <= trimester[1]) {
            from.setMonth(trimester[0]);
            to.setFullYear(from.getFullYear(), trimester[1] + 1, 1);
            to.setDate(to.getDate() - 1);
        }
    });
    return { from: from, to: to };
}
export function getThisTrimester() {
    return getTrimester();
}
export function getLastTrimester() {
    return getTrimester(-1);
}

export function minuteToTime(duration: number) {
    const minutes = Math.floor(duration % 60);
    const hours = Math.floor((duration / 60) % 24);

    return (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes);
}

export function minuteToTimeComma(duration: number) {
    const minutes = Math.floor(duration % 60);
    const hours = Math.floor((duration / 60) % 24);

    return hours + 'h' + (minutes < 10 ? '0' + minutes : minutes);
}

export function millisecondsToTime(duration: number, hasMilliseconds: boolean = false) {
    const milliseconds = Math.floor((duration % 1000) / 100);
    const seconds = Math.floor((duration / 1000) % 60);
    const minutes = Math.floor((duration / (1000 * 60)) % 60);
    const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

    return (
        (hours < 10 ? '0' + hours : hours) +
        ':' +
        (minutes < 10 ? '0' + minutes : minutes) +
        ':' +
        (seconds < 10 ? '0' + seconds : seconds) +
        (hasMilliseconds ? '.' + milliseconds : '')
    );
}

export function toLocaleTimeString(date: Date) {
    // retourne hh:mm en accords avec timezone client;
    // '.replace()' fixe l'affichage sur edge qui incorpore des charactères vide
    return date
        .toLocaleTimeString()
        .replace(/\u200E/g, '')
        .substring(0, 5);
}

export function toTimestamp(date) {
    if (date === null) {
        return null;
    }
    date = new Date(date);
    // valueOf permet de récupérer le timestamp
    const timestampToday = date.valueOf();
    return timestampToday;
}

export function getTimeZone() {
    const date = new Date();
    let currentTimezone = date.getTimezoneOffset();
    currentTimezone = (currentTimezone / 60) * -1;
    let gmt = '';
    if (currentTimezone !== 0) {
        gmt += currentTimezone > 0 ? '+' : ' ';
        gmt += (currentTimezone < 10 ? '0' + currentTimezone : currentTimezone) + ':00';
    }
    return gmt;
}

export function setDateHourForCourse(course) {
    course.start = getDateHour(course.date, course.start);
    course.end = getDateHour(course.date, course.end);
}

export function getDateHour(date, hour) {
    let dateHour;
    if (hour.length === 5) {
        dateHour = formatTime(setDateTime(date, setTimeGmt(date, hour)));
    } else {
        dateHour = formatTime(setDateTime(date, hour));
    }
    return dateHour;
}
